import * as React from 'react'
import { useIntl } from '@/intl'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { getParticipantTitleTextKey } from '@/scopes/checkout/domain/participantTitleText'
import { ParticipantFormType } from '@/scopes/checkout/domain/types/participantFormType'
import { ParticipantTitle } from '@/scopes/checkout/domain/types/participantTitle'
import { ToggleButtonGroupInput } from '@/scopes/common/components/FormElements/ToggleButtonGroupInput'
import styles from '../Form.module.css'

const titlesByParticipantType: Record<ParticipantFormType, ParticipantTitle[]> = {
  MainBooker: [ParticipantTitle.Mr, ParticipantTitle.Ms],
  Adult: [ParticipantTitle.Mr, ParticipantTitle.Ms],
  Child: [ParticipantTitle.KidMale, ParticipantTitle.KidFemale],
  Baby: [ParticipantTitle.BabyMale, ParticipantTitle.BabyFemale],
}

export function TitleInput({
  name,
  required,
  participantType,
}: {
  name: string
  required?: boolean
  participantType: ParticipantFormType
}) {
  const intl = useIntl()
  useTrackFieldValidation(name)

  const items = titlesByParticipantType[participantType].map(value => ({
    value,
    title: intl.formatMessage({ id: getParticipantTitleTextKey(value) ?? '' }),
  }))

  const requiredErrorMessage = {
    MainBooker: intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_title_main_booker' }),
    Adult: intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_title' }),
    Child: intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_title' }),
    Baby: intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_title' }),
  }

  return (
    <ToggleButtonGroupInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_title' })}
      required={required}
      requiredErrorMessage={requiredErrorMessage[participantType]}
      items={items}
      formFieldClass={styles.personalDetailsFormField}
    />
  )
}
